export const TVF_ITEMS = [
  {
    title: 'Operacional',
    itens: [
      {
        label: 'Trades',
        icon: 'description',
        materialIcon: true,
        route: 'pedidos',
        flag: 'OT',
      },
      {
        label: 'Triagem',
        icon: 'collections_bookmark',
        materialIcon: true,
        route: 'triagem/buscar',
        flag: 'OTR',
      },
      {
        label: 'Usuários',
        icon: 'supervisor_account',
        route: 'acessos/usuarios',
        materialIcon: true,
        flag: 'OU',
      },
      {
        label: 'Criar Lote',
        icon: 'create_new_folder',
        materialIcon: true,
        route: 'lotes/novo',
        flag: 'OCL',
      },
      {
        label: 'Editar Lote',
        icon: 'edit_square',
        materialIcon: true,
        route: 'lotes',
        flag: 'OEL',
      },
      {
        label: 'Varejistas',
        icon: 'shopping_cart',
        route: 'varejistas',
        materialIcon: true,
        flag: 'OV',
      },
      {
        label: 'Lojas',
        icon: 'storefront',
        route: 'lojas',
        materialIcon: true,
        flag: 'OL',
      },
      {
        label: 'Transportadoras',
        icon: 'local_shipping',
        route: 'transportadoras',
        materialIcon: true,
        flag: 'OTP',
      },
      {
        label: 'Controle de Qualidade',
        icon: 'verified_user',
        route: 'controle-qualidade',
        materialIcon: true,
        flag: 'OCQ',
      },
      {
        label: 'Recebimento',
        icon: 'inventory',
        route: 'recebimento',
        materialIcon: true,
        flag: 'ORCV',
      },
      {
        label: 'Reincidência',
        icon: 'mobile_screen_share',
        route: 'reincidencia',
        materialIcon: true,
        flag: 'ORD',
      },
      {
        label: 'Gestão de Erros',
        icon: 'error_outline',
        route: 'error-manager',
        materialIcon: true,
        flag: 'OGE',
      },
      {
        label: 'Controle de LMR',
        icon: 'dashboard',
        route: 'lmr',
        materialIcon: true,
        flag: 'CLMR',
      },
    ],
  },
  {
    title: 'Relatórios',
    itens: [
      {
        label: 'Financeiro Varejo',
        icon: 'request_quote',
        route: 'relatorio/financeiro',
        materialIcon: true,
        flag: 'RF',
      },
      {
        label: 'Relatório de Trades',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/pedidos',
        flag: 'RT',
      },
      {
        label: 'Relatório de Pendências',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/pendencias',
        flag: 'RP',
      },
      {
        label: 'Relatório de Divergências',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/divergencias',
        flag: 'RD',
      },
      {
        label: 'Histórico de Transportes',
        icon: 'local_shipping',
        materialIcon: true,
        route: 'relatorio/transportes',
        flag: 'RHT',
      },
      {
        label: 'Relatório de Notas',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/notas',
        flag: 'RN',
      },
      {
        label: 'Linha do tempo',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/timeline',
        flag: 'RLT',
      },

      {
        label: 'Relatório de Erros',
        icon: 'assignment',
        materialIcon: true,
        route: 'relatorio/dlqs',
        flag: 'RDLQ',
      },
      {
        label: 'Logs',
        icon: 'assignment',
        materialIcon: true,
        route: 'logs',
        flag: 'RL',
      },
    ],
  },
];
